import createModel from 'utils/model'
import _ from 'lodash'
import {
    getCustomerList,
    getCustomerGrouping,
    deleteGrouping,
    addGrouping,
    editGrouping,
    moveGrouping,
    getMoveCount,
} from 'crm/services/customer-grouping'

function getInitTableParamsState() {
    return {
        keyword: undefined,
        user_id: undefined,
        group_id: undefined, // 当前分组的id
        limit: 10,
        offset: 0,
    }
}

function getInitTableState() {
    return {
        params: getInitTableParamsState(),
        total: 0,
        current: 1,
        tableData: [],
        customerGroupingList: [], // 客户分组列表
        name: undefined, // 新增/修改：分组的名字
        selectedRowKeys: [],
        selectedRows: [],
        allMoveCount: 0, // 移动的好友数
    }
}

export default createModel({
    namespace: 'crm_customerGrouping',

    state: {
        ...getInitTableState(),
    },

    effects: {
        *getCustomerList({payload}, {select, call, put}) {
            const {params, current, selectedRowKeys, selectedRows} = yield select(
                ({crm_customerGrouping}) => crm_customerGrouping,
            )

            const newParams = _.cloneDeep(params)

            if (payload.page) {
                newParams.offset = newParams.limit * (payload.page - 1)
            }
            const res = yield call(getCustomerList, newParams)

            if (res && res.data) {
                // 处理企业标签
                const tableData = res.data

                // 处理已选的userId的关联
                const addKeys = []
                const addRows = []
                selectedRows.forEach((row) => {
                    tableData.forEach((record) => {
                        if (record.external_userid === row.external_userid) {
                            if (
                                selectedRows.findIndex(
                                    (newStateRow) => newStateRow.id === record.id,
                                ) < 0 &&
                                addRows.findIndex((newStateRow) => newStateRow.id === record.id) < 0
                            ) {
                                addKeys.push(record.id)
                                addRows.push(record)
                            }
                        }
                    })
                })
                const newSelectedRowKeys = selectedRowKeys.concat(addKeys)
                const newSelectedRows = selectedRows.concat(addRows)

                yield put({
                    type: 'setProperty',
                    payload: {
                        tableData,
                        total: _.get(res, 'pagination.rows_found', 0),
                        current: _.get(payload, 'page', current),
                        selectedRowKeys: newSelectedRowKeys,
                        selectedRows: newSelectedRows,
                    },
                })
            }
        },

        *getCustomerGrouping({callback}, {call, put}) {
            const res = yield call(getCustomerGrouping)

            if (res && res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        customerGroupingList: res.data,
                    },
                })
                callback && callback(res.data)
            }
        },

        *deleteGrouping({payload, callback}, {call}) {
            const res = yield call(deleteGrouping, payload)

            if (res && res.meta.code === 200) {
                callback && callback()
            }
        },

        *addGrouping({payload, callback}, {call}) {
            const res = yield call(addGrouping, payload)

            if (res && res.meta.code === 200) {
                callback && callback()
            }
        },

        *editGrouping({payload, callback}, {call}) {
            const res = yield call(editGrouping, payload)

            if (res && res.meta.code === 200) {
                callback && callback()
            }
        },

        *moveGrouping({payload, callback}, {call}) {
            const res = yield call(moveGrouping, payload)

            if (res && res.meta.code === 200) {
                callback && callback()
            }
        },

        *getMoveCount({payload, callback}, {call, put}) {
            const res = yield call(getMoveCount, payload)

            if (res && res.data) {
                yield put({
                    type: 'setProperty',
                    payload: {
                        allMoveCount: res.data.count,
                    },
                })
                callback && callback()
            }
        },
    },

    reducers: {
        resetTableParams(state) {
            return {...state, params: getInitTableParamsState()}
        },
        resetTable(state) {
            return {...state, ...getInitTableState()}
        },
        mergeTableParams(state, action) {
            return {...state, params: {...state.params, ...action.payload}}
        },
    },
})
